import { Component, AfterContentInit, OnDestroy, ElementRef } from '@angular/core';
import { PlycaDataService } from '../../../services/plyca.service';
import { UIService } from '../../ui.service';
import { EventAuditDTO, EventAuditFiltersDTO } from '../../api/plyca-dtos-v2';
import { PaginationDTO } from '../../api/PaginationModel';
import { UserService } from '../../user.service';
import { FieldConfig } from '../../api/contract-notice-dto';
import { HelpService, HelpType } from '../../components/common/help/help.service';
import { HeaderActionsService } from '../../components/common/sub-header/header-actions.service';
import { BaseComponent } from '../../components/common/baseComponent/base.component';

@Component({
  selector: 'eventAuditPanel',
  templateUrl: 'eventAuditPanel.template.html'
})
export class eventAuditPanelComponent extends BaseComponent
  implements AfterContentInit, OnDestroy {
  loaded = false;
  audits: EventAuditDTO[] = [];
  filters: EventAuditFiltersDTO;
  public FROM_PARAM = 'from';
  public TO_PARAM = 'to';
  public USER_PARAM = 'user';

  constructor(
    public plycaService: PlycaDataService,
    public uiService: UIService,
    public helpService: HelpService,
    private headerActionsService: HeaderActionsService,
    private elem: ElementRef,
    public userService: UserService
  ) {
    super();
    this.subscribe(this.helpService.showContextHelpObservable(HelpType.AUDIT));

  }


  ngAfterContentInit(): void {

    this.headerActionsService.setTaskDescription(this.elem, 'Monitorization.title', 'far fa-file', true);
    this.headerActionsService.addDivider();
    this.subscribe(
      this.headerActionsService.addAction(
        'General.back',
        'fas fa-chevron-left',
        'btn-outline-secondary',
        true
      ), success => {
        this.uiService.routeBack();
      });

    this.filters = new EventAuditFiltersDTO();
    let date = new Date();
    date.setDate(date.getDate() - 7);
    this.filters.from = date;
    this.filters.user = this.userService.getUser();
    this.search();

  }

  ngOnDestroy(): void { }

  public isLoaded(): boolean {
    return this.loaded;
  }

  public search() {
    this.loaded = false;
    this.audits = [];
    this.subscribe(
      this.plycaService
        .getEventAudits(this.filters2string())
      , (result: PaginationDTO<EventAuditDTO>) => {
        if (result && result.content) {
          this.audits = result.content;
        }
        this.loaded = true;
      });
  }

  private filters2string(): string {
    let filterStr = '';
    if (this.filters.size) {
      if (filterStr !== '') {
        filterStr += '&';
      }
      filterStr += 'size=' + this.filters.size + '&page=0';
    }

    if (this.filters.from) {
      if (filterStr !== '') {
        filterStr += '&';
      }
      filterStr += 'dateFrom=' + this.filters.from.getTime();
    }
    if (this.filters.to) {
      if (filterStr !== '') {
        filterStr += '&';
      }
      filterStr += 'dateTo=' + this.filters.to.getTime();
    }

    if (this.filters.operationTimeFrom) {
      if (filterStr !== '') {
        filterStr += '&';
      }
      filterStr += 'operationTimeFrom=' + this.filters.operationTimeFrom;
    }

    if (this.filters.user) {
      if (filterStr !== '') {
        filterStr += '&';
      }
      filterStr += 'user=' + this.filters.user.identifier;
    }
    console.log('FILTROS!!', filterStr);
    return filterStr;
    // return Object.keys(this.userPrefs.dossiersViewPrefs.filters)
    //   .filter(k => this.userPrefs.dossiersViewPrefs.filters[k])
    //   .map(k => {
    //     if (this.userPrefs.dossiersViewPrefs.filters[k]) {
    //       let val = this.userPrefs.dossiersViewPrefs.filters[k];
    //       // 10.8 Workarround solucionar el problema del id compuesto de los MasterData
    //       if (typeof val === 'string' && val.indexOf('<>') != -1) {
    //         val = val.substring(0, val.indexOf('<>'));
    //       }
    //       return `${encodeURIComponent(k)}=${encodeURIComponent(val)}`;
    //     }
    //   })
    //   .join('&');
  }

  public getFieldConfig(name: string): FieldConfig {
    let config = new FieldConfig();
    config.fieldStyle = 'col-12';
    config.jsonField = name;
    if (name === this.FROM_PARAM) {
      config.type = 'DATETIME';
      config.description = 'Fecha desde:';
    } else if (name === this.TO_PARAM) {
      config.type = 'DATETIME';
      config.description = 'Fecha hasta:';
    } else if (name === this.USER_PARAM) {
      config.type = 'SEARCH';
      config.description = 'Usuario';
      config.idBuscador =
        'com.nexusit.framework.buscador.interfaz.BuscadorUsuarios';
      config.autoSearch = false;
    }
    return config;
  }
}
